export const FILTER_MESSAGES = {
	SEARCH: 'Tìm kiếm',
	STATUS: 'Trạng thái',
};
